import { render } from "./ViolationConsequenciesForm.vue?vue&type=template&id=55fc413f"
import script from "./ViolationConsequenciesForm.vue?vue&type=script&lang=js"
export * from "./ViolationConsequenciesForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__